import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../../partials/aside/Sidebar";
import TitleBar from "../../../partials/content/TitleBar";
import httpService from "../../../../services/httpServices/httpServices";
import helperNumber from "../../../../helpers/numbers";
import helperSpinner from "../../../../helpers/spinner";
import Pagination from "../../../partials/content/Pagination";
import TypeRoleUser from "./TypeRoleUser";

export default function AllUser() {
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [userIDSearchFilter, setUserIDSearchFilter] = useState();

  useEffect(() => {
    getUsers();
  }, []);

  useEffect(() => {
    getUsers();
  }, [currentPage, countItemPerPage, userIDSearchFilter]);

  const getUsers = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let users = await sendRequestGetUsers(searchFilterQuery);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!users) {
      return;
    }

    setUsers(users.users);
    setCountPage(users.count_page);
  };

  const sendRequestGetUsers = async (searchFilterQuery) => {
    const headersRequest = getHeaderRequest();
    let users;
    try {
      users = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/manage/publisher/user/all-publisher?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return users.data.data;
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const enterUserProfile = async (userID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let token = await sendRequestGetTokenUser(userID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!token) {
      return;
    }

    localStorage.removeItem("token");
    localStorage.setItem("token", token);
    const url = process.env.REACT_APP_DOMAIN + "/site/all";
    window.location.replace(url);
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (userIDSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&id=${userIDSearchFilter}`;
    }

    return searchFilterQuery;
  };

  const sendRequestGetTokenUser = async (userID) => {
    let token;
    let headersRequest = getHeaderRequest();
    try {
      token = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/user/enter-users-profile/" +
          userID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return token.data.data;
  };

  const generateHtmlTagUsers = () => {
    return (
      <>
        <div class="container-fluid pb-2">
          <div class="row border border-1 rounded py-2">
            <div class="col-12 col-md-4">
              <div>
                <label>جستجو در نام کمپین</label>
              </div>
              <div>
                <input
                  className="form-control"
                  type="text"
                  placeholder="نام کمپین را در اینجا وارد کنید "
                  onWheel={(event) => event.currentTarget.blur()}
                  onKeyUp={(e) => setUserIDSearchFilter(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره کاربری</td>
                <td>نام</td>
                <td>نام خانوداگی</td>
                <td>موجودی (تومان)</td>
                <td>امتیاز</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {users.map((user, index) => {
                return (
                  <tr>
                    <td>{helperNumber.toPersianNum(index + 1)}</td>
                    <td>{user.user_id}</td>
                    <td>{user.firstname}</td>
                    <td>{user.lastname}</td>
                    <td className="letter-spacing-finance-number">
                      {helperNumber.toPersianNum(
                        helperNumber.toFormatFinanceNumber(
                          user.publisher_wallet
                        )
                      )}
                    </td>
                    <td className="letter-spacing-finance-number">
                      {helperNumber.toPersianNum(
                        helperNumber.toFormatFinanceNumber(user.publisher_score)
                      )}
                    </td>
                    <td>
                      <span className="pl-2">
                        <span
                          className="btn btn-success  "
                          onClick={() => enterUserProfile(user.user_id)}
                        >
                          <i className="fa fa-sign-in-alt"></i>
                        </span>
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {countPage > 1 ? generatePagination() : <></>}
      </>
    );
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  return (
    <>
      <Sidebar openItem="manage-users" activeItem="list-user" />

      <div className="content-wrapper">
        <TitleBar title="کاربران نمایش دهنده" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              {users.length == 0 && userIDSearchFilter == null ? (
                <></>
              ) : (
                generateHtmlTagUsers()
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
